var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThefork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00001 12.084C2.00498 7.55626 5.41607 3 12.1309 3C18.6708 3 22.0755 7.60709 21.9987 11.9702C21.9099 17.028 18.4533 19.6443 15.3571 20.5849L15.0038 19.0769C14.8197 18.2863 15.0386 17.581 15.6124 17.0825C16.3532 16.4379 16.7947 15.6408 17.0243 14.5387C17.2667 13.3735 17.153 12.0947 16.6141 10.8174L14.7827 5.79392H12.9456L14.4137 11.5324C14.5481 12.1039 14.103 12.649 13.5016 12.649L11.7178 5.01907H10.0486L11.6546 14.4352C10.6486 14.5232 10.2761 13.8869 10.1929 13.4264L9.16841 6.31489H7.47211C7.47211 6.31489 7.48277 10.1461 7.48277 12.7626C7.48277 16.6082 9.59 17.753 11.0453 18.0945C11.8686 18.2876 12.4188 18.9121 12.5681 19.7888L12.775 21C9.65753 21.0078 1.99148 19.8762 2.00001 12.084Z",
    fill: "#00665C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThefork);
export default __webpack_public_path__ + "static/media/thefork.153081eeca22f2c494093b78830e1322.svg";
export { ForwardRef as ReactComponent };